import React, {Component} from "react"
import * as PropTypes from "prop-types"
import styled from "styled-components"
import {get} from "lodash"
import {withRouter} from "react-router-dom"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import SearchBar from "@irati-web/search/src/components/Popups/SearchBar"
import id from "@irati/utils/id"
import {connect} from "@irati/store/connect"
import tracking from "@irati-tracking/perks/perks"
import authentication from "@irati/auth"
import {ReduxState} from "@irati/store/types"

import HeaderLink from "./HeaderLink"

interface Props {
  className: string,
  match?: any,
  search?: any
}

class Search extends Component<Props> {
  static defaultProps = {
    match: {},
    search: {}
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired,
    apps: PropTypes.object.isRequired
  }

  state = {
    show: false
  }

  handleSearch = () => {
    const {show} = this.state
    const query = get(this.props.match, "path", "")

    if (query !== "/search") {
      if (!show) {
        tracking.startSearch()
      }

      this.setState({show: !show})
    } else {
      tracking.startSearch()
      const searchResultsInput = this.props.search.searchResultsInput
      if (searchResultsInput) {
        searchResultsInput.focus()
      }
    }
  }

  render() {
    const {show} = this.state
    const {isMobile} = this.props
    const {apps, appPath} = this.context
    const isLoggedIn = authentication.isLoggedIn()
    const shouldShow = appPath === apps.PERKS || appPath === apps.SEARCH || appPath === apps.WALLET

    if (!isLoggedIn || !shouldShow) {
      return null
    }

    // This will be used when we get mobile designs
    const showText = false

    const idNamespace = id("search", this.props)
    const idLink = id("link-search", idNamespace)

    return (
      <div id={idNamespace} className={this.props.className}>
        <HeaderLink id={idLink} onClick={this.handleSearch}>
          <Icon id={id("icon", idLink)} icon={IconTypes.search} size={isMobile ? 24 : 20} />
          {showText && "Search"}
        </HeaderLink>
        <SearchBar id={idNamespace} show={show} onClose={this.handleSearch} />
      </div>
    )
  }
}

const mapStateToProps = ({mq, search}: ReduxState) => ({isMobile: mq.lessThan.sm, search})


export default connect(mapStateToProps)(withRouter(styled(Search)``))
